export {default as handShakeIcon} from './handshake.png';
export {default as keyIcon} from './key.png';
export {default as rocketIcon} from './rocket.png';
export {default as addUserIcon} from './add-user.png';
export {default as moneyIcon} from './money.png';
